import { useQuery } from '@tanstack/react-query';

import { apiClient } from '@/lib/api/client';
import { useTenantStore } from '@/stores/tenantStore';

import { pagedWorkflowsSchema } from '../schemas/workflowSchemas';
import { workflowKeys } from './workflowKeys';

interface ListWorkflowsParams {
  page: number;
  pageSize: number;
  search?: string;
  status?: string;
}

export function useListWorkflows({ page, pageSize, search, status }: ListWorkflowsParams) {
  const tenantId = useTenantStore((s) => s.tenantId);

  return useQuery({
    queryKey: workflowKeys.list({ page, pageSize, search, status }),
    queryFn: async ({ signal }) => {
      const searchParams: Record<string, string | number> = { page, pageSize };
      if (search) searchParams.search = search;
      if (status) searchParams.status = status;

      const raw = await apiClient
        .get(`api/v1/t/${tenantId}/workflows`, { searchParams, signal })
        .json();

      return pagedWorkflowsSchema.parse(raw);
    },
    enabled: !!tenantId,
  });
}
